export default "__VITE_ASSET__DBjXPruf__"